export default __webpack_public_path__ + "static/img/23.5820024.png";